"use client";

import { adminUserListExport } from "@/entities";
import { useMutation } from "@tanstack/react-query";
import { useSearchParams } from "next/navigation";
import { toast } from "react-toastify";

export function AdminUsersButtons() {
  const searchParams = useSearchParams();
  const keyword = searchParams?.get("keyword") || "";

  const exportMutation = useMutation({
    mutationFn: adminUserListExport,
    onSuccess: () => {
      toast.success("내보내기 완료");
    },
    onError: () => {
      toast.error("내보내기 실패");
    },
  });

  const onExport = async () => {
    if (exportMutation.isPending) return;

    const { result } = await exportMutation.mutateAsync({ keyword });

    const link = document.createElement("a");
    const blobUrl = window.URL.createObjectURL(result);
    link.setAttribute("href", blobUrl);
    link.setAttribute("download", "users.xlsx");
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  return (
    <>
      <div className="mb-3 d-md-flex fw-bold">
        <div className="me-md-4 mt-md-0 mt-2">
          <button
            type="button"
            className="text-decoration-none text-dark"
            onClick={onExport}
          >
            <i className="fa fa-download fa-fw me-1 text-dark text-opacity-50"></i>
            내보내기
          </button>
        </div>
      </div>
    </>
  );
}
